/*
  Noah.Q PC virtual canvas controller v232

  Reference canvas: 1600 x 900
  Scale = min(viewportWidth / 1600, viewportHeight / 900)

  On wide displays, height determines the scale and the remaining
  horizontal space stays as background.

  Runtime wrappers are used only on desktop for VALUES and CTA.
  Mobile DOM is restored when crossing below 990px.
*/
(function () {
  'use strict';

  var BASE_W = 1600;
  var BASE_H = 900;
  var DESKTOP_QUERY = '(min-width: 990px)';
  var rafId = 0;

  function getHome() {
    return document.querySelector('.noahq-home');
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function getViewport() {
    var vv = window.visualViewport;
    return {
      width: vv ? vv.width : window.innerWidth,
      height: vv ? vv.height : window.innerHeight
    };
  }

  function setScale(home) {
    var viewport = getViewport();
    var scale = Math.min(viewport.width / BASE_W, viewport.height / BASE_H);

    if (!Number.isFinite(scale) || scale <= 0) {
      scale = 1;
    }

    home.style.setProperty('--nq-canvas-scale', scale.toFixed(6));
    home.style.setProperty('--nq-scaled-width', (BASE_W * scale).toFixed(3) + 'px');
    home.style.setProperty('--nq-scaled-height', (BASE_H * scale).toFixed(3) + 'px');
  }

  function wrapChildren(container, modifier) {
    if (!container || container.querySelector(':scope > .noahq-pc-canvas')) {
      return;
    }

    var canvas = document.createElement('div');
    canvas.className = 'noahq-pc-canvas ' + modifier;
    canvas.setAttribute('data-noahq-runtime-canvas', modifier);

    while (container.firstChild) {
      canvas.appendChild(container.firstChild);
    }

    container.appendChild(canvas);
  }

  function unwrapChildren(container) {
    if (!container) return;

    var canvas = container.querySelector(':scope > [data-noahq-runtime-canvas]');
    if (!canvas) return;

    while (canvas.firstChild) {
      container.insertBefore(canvas.firstChild, canvas);
    }

    canvas.remove();
  }

  function markStaticCanvases(home, enabled) {
    var heroStage = home.querySelector('.noahq-hero__stage');
    var drop = home.querySelector('.noahq-scroll-showcase__sticky > .noahq-drop');

    if (heroStage) {
      heroStage.classList.toggle('noahq-pc-canvas-static', enabled);
    }

    if (drop) {
      drop.classList.toggle('noahq-pc-canvas-static', enabled);
    }
  }

  function mountDesktop(home) {
    setScale(home);

    var valuesSticky = home.querySelector('.noahq-values__sticky');
    var cta = home.querySelector('section.noahq-cta');

    wrapChildren(valuesSticky, 'noahq-vcanvas--values');
    wrapChildren(cta, 'noahq-vcanvas--cta');
    markStaticCanvases(home, true);

    home.classList.add('noahq-pc-virtual-canvas-active');
  }

  function unmountDesktop(home) {
    var valuesSticky = home.querySelector('.noahq-values__sticky');
    var cta = home.querySelector('section.noahq-cta');

    unwrapChildren(valuesSticky);
    unwrapChildren(cta);
    markStaticCanvases(home, false);

    home.classList.remove('noahq-pc-virtual-canvas-active');
    home.style.removeProperty('--nq-canvas-scale');
    home.style.removeProperty('--nq-scaled-width');
    home.style.removeProperty('--nq-scaled-height');
  }

  function apply() {
    rafId = 0;

    var home = getHome();
    if (!home) return;

    if (isDesktop()) {
      mountDesktop(home);
    } else {
      unmountDesktop(home);
    }
  }

  function schedule() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(apply);
  }

  function start() {
    apply();

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
    }

    var media = window.matchMedia(DESKTOP_QUERY);
    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', schedule);
    } else if (typeof media.addListener === 'function') {
      media.addListener(schedule);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
